
import { mapActions, mapState, mapGetters } from "vuex";
import ResponsiveDialog from "./responsive-dialog.vue";

export default {
  components: { ResponsiveDialog },
  props: {
    dialog: false
  },
  data() {
    return {
      rateCardData: [
        { label: "0-3 Km ", rate: "INR 45" },
        { label: "Additional per Km ", rate: "INR 13" },
        { label: "Weekend Surge ", rate: "INR 5" },
        { label: "Peak Premium (8-11 PM) ", rate: "INR 5" },
        { label: "Rain Surge ", rate: "INR 25" },
        { label: "Festival Surge", rate: "As applicable" },
        { label: "GST ", rate: "As applicable" }
      ]
    };
  }
};
